import {icon, pdf} from './ItemCertificate/DataItemCertificate'
import ItemCertificate from './ItemCertificate/ItemCertificate'

export default function MyCertificates() {
  return(<>
    <ItemCertificate index={1} img={icon.MySQLImg}      title="MySQL"  pdf={pdf.MySQLPdf}/>
    <ItemCertificate index={2} img={icon.JavascriptImg} title="Javascript"  pdf={pdf.JavascriptPdf}/>
    <ItemCertificate index={3} img={icon.GitGubImg}     title="Git e GitHub"  pdf={pdf.GitGubPdf}/>
    <ItemCertificate index={4} img={icon.UnityImg}      title="Unity 3D"  pdf={pdf.UnityPdf}/>
    <ItemCertificate index={5} img={icon.OminStackImg}  title="OmniStack"  pdf={pdf.OminStackPdf}/>

  </>);
}